/**
 * Created by pawel on 2017-07-14.
 */
(function () {

    window.pw.doc('Bs3Tab', '0.1.0', '+cookie +segment');

    $(document).on('shown.bs.tab', 'a[data-toggle="tab"]',function (e) {

        var a = $(this),
            ul = a.parents('ul.nav:eq(0)'),
            val = a.attr('href'),
            id = null
        ;

        if(ul.attr('data-cookie-id')) {
            var cookieId = 'ul[data-cookie-id="'+ ul.attr('data-cookie-id') +'"]';
            console.debug(cookieId, val);
            $.cookie(cookieId, val, { expires: 1, path: '/' } );
        }

        $('[data-segment]').trigger('pw.segment');

    }).on('pw.tabs.init', 'ul[data-cookie-id]', function () {

        var ul = $(this),
            cookieId = 'ul[data-cookie-id="'+ ul.attr('data-cookie-id') +'"]',
            val = $.cookie(cookieId)
            ;

        if(val) {
            var a = $('a[href="'+val+'"]');
            a.tab('show');
        }

   }).on('pw.segment.postLoad', function (e, wrapper) {
        if(wrapper) {
            var tabs = wrapper.find('ul[data-cookie-id]');
            if(tabs.length) {
                tabs.trigger('pw.tabs.init');
            }
        }
    });

    $('ul[data-cookie-id]').trigger('pw.tabs.init');

})(jQuery);